import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';

export const SummaryStyled = styled(Box).attrs({ px: { sm: '500' }, pb: { sm: '500' }, pt: { sm: '600' } })`
  ${({ theme }) => css`
    border-top-left-radius: ${theme.spacings[200]};
    border-top-right-radius: ${theme.spacings[200]};
    background: ${theme.colors.grey[200]};
    border-bottom: solid 1px ${theme.colors.grey[300]};
  `}
`;
